import { Layout } from 'antd'
import styled from 'styled-components'

import {
  HEADER_HEIGHT,
  HEADER_PADDING_TOP
} from '@configs'
import { ILayout } from '@interfaces'
import { HeaderNodule, InnerAppModule, SidebarModule } from '@modules'
import { selectLayout, useAppSelector } from '@redux'
import { useEffect } from 'react'

export const AppLayout = (props: ILayout) => {
  const { children } = props
  const { sidebarCollapsed } = useAppSelector(selectLayout)

  useEffect(() => {
    // Location changed
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }, []);

  return (
    <StyledAppLayout className="main-layout">
      <HeaderNodule />
      <Layout className="content-layout">
        <SidebarModule />
        <StyledPageInner
          className="max-w-full overflow-x-hidden"
          sidebarCollapsed={sidebarCollapsed}
        >
          <InnerAppModule {...props}>{children}</InnerAppModule>
        </StyledPageInner>
      </Layout>
    </StyledAppLayout>
  )
}

const StyledAppLayout = styled((props) => <Layout {...props} />)`
  min-height: 100vh;
  background: #f1f5f9;
`

const StyledPageInner = styled.div<{
  sidebarCollapsed?: boolean
  backgroundColor?: string
  backgroundColor2?: string
}>`
  background: #f1f5f9;
  transition: all 0.3s;
  padding: calc(${HEADER_HEIGHT} + ${HEADER_PADDING_TOP} + 2rem) 1.375rem calc(${HEADER_PADDING_TOP} + 2rem);
  display: flex;
  flex-direction: column;
  position: relative;
  flex: 1;
`
